<template>
    <div id="sidebar">
        <div class="logo-container" >
            <div class="toggle-sidebar" @click="toggle_sidebar"> 
                <i class="fas fa-bars"></i>
            </div>
        </div>
        <div class="nav" :class="{sidebar_hidden :is_sidebar_hidden}" >
            <ul>
                <li>
                    <router-link to="">
                        <div class="icon">
                            <img src="../assets/classes.png" alt="">
                        </div>
                    </router-link>
                </li>
                <li>
                    <router-link to="">
                        <div class="icon assignment-icon">
                            <img src="../assets/assignment.png"  alt="">
                        </div>
                    </router-link>
                </li>
                <li>
                    <router-link to="">
                        <div class="icon ">
                            <img src="../assets/sm.png"  alt="">
                        </div>
                    </router-link>
                </li>
                
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            is_sidebar_hidden:false
        }
    },
    methods: {
        toggle_sidebar(){
            console.log("hello")
            this.is_sidebar_hidden = !this.is_sidebar_hidden
            this.$parent.toggle_main_area(this.is_sidebar_hidden)
        }
    },
}
</script>
<style scoped>

#sidebar{
    height: 100%;
    width:5rem;
    /* border-right: 2px solid #e2e2e2; */
    position: fixed;
    top:0;
    left:0;z-index: 2;
}
/* #sidebar::before{
    content: "";
    position: absolute;
    top:.5rem;
    right:0px;
    width:2px;
    height: 4rem;
    background-color:#e9e9e9;
} */
.logo-container{
    width: 100%;
    height: 5rem;
    position: relative;
    
}
/* .logo-container::after{
    content: "";
    position: absolute;
    top:100%;
    left:.5rem;
    width:4rem;
    height: 2px;
    background-color:#e9e9e9;
} */
.toggle-sidebar{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.toggle-sidebar i{
    color:#002486;
    font-size: 2.5rem;
}

.nav{
    position: relative;
    background-color: #ffffff;
    padding-top: 2rem;
    transition: .3s all;
    height: calc(100% - 5rem);
}
.nav::after{
    content: "";
    position: absolute;
    top:0;
    right:0px;
    width:2px;
    height: calc(100% - 5rem);
    background-color:#e9e9e9;
}
.sidebar_hidden{
    transform: translateX(-100%);
}
ul>li{
    margin-bottom: 2rem;
}

ul>li a{
    display: block;
}
.icon{
    border-radius: 50%;
    margin: 0 auto;
    background-color: #002486;
    width: 3.5rem;
    height: 3.5rem;
    text-align: center;
    padding-top: .3rem;
}
.icon img{
    
    width: 2.8rem;
    height: 2.8rem;
}

</style>


// WEBPACK FOOTER //
// src/components/Sidebar.vue